const LAST_SLASH_REGEX = /\/$/;
const EXT_SLASH_REGEX = /\/\/+/g;

type QueryStringDetail = {
  keys: string[];
  queries: { [key: string]: string };
};

const normalizePath = (path: string) => {
  return path.replace(LAST_SLASH_REGEX, '').replace(EXT_SLASH_REGEX, '/');
};

const splitQuery = (queryString: string): QueryStringDetail => {
  return queryString
    .slice(1, queryString.length)
    .split('&')
    .reduce(
      (result, qs) => {
        const [key, value = ''] = qs.split('=');
        // eslint-disable-next-line no-param-reassign
        result.keys.push(key);
        // eslint-disable-next-line no-param-reassign
        result.queries[key] = value;
        return result;
      },
      { keys: [], queries: {} } as QueryStringDetail
    );
};

export class LocationHelper {
  public static isSamePath(pathA: string, pathB: string) {
    return normalizePath(pathA) === normalizePath(pathB);
  }

  public static isSameQuery(locationSearchStringA: string, locationSearchStringB: string) {
    const a = splitQuery(locationSearchStringA);
    const b = splitQuery(locationSearchStringB);
    return (
      a.keys.length === b.keys.length &&
      a.keys.every((key) => {
        return b.queries[key] === a.queries[key];
      })
    );
  }

  public static isSameHash(hashA: string, hashB: string) {
    const a = normalizePath(hashA.slice(1, hashA.length));
    const b = normalizePath(hashB.slice(1, hashB.length));
    if ((!a && b === '/') || (a === '/' && !b)) {
      return true;
    }
    return a === b;
  }
}
